export function buildGarageMobileSearchPath({ mobile, podiumId, locationId }) {
    const params = new URLSearchParams();

    const normalizedMobile = String(mobile || "").trim();
    if (normalizedMobile) params.set("mobile", normalizedMobile);
    if (podiumId != null && podiumId !== "") params.set("podiumId", String(podiumId));
    if (locationId != null && locationId !== "") params.set("locationId", String(locationId));

    const qs = params.toString();
    return qs ? `/garage?${qs}` : "/garage";
}

export function parseGarageMobileSearch(search) {
    const params = new URLSearchParams(search || "");
    return {
        mobile: (params.get("mobile") || "").trim(),
        podiumId: params.get("podiumId") ? Number(params.get("podiumId")) : null,
        locationId: params.get("locationId") ? Number(params.get("locationId")) : null,
        lostkeys: params.get("lostkeys"),
    };
}
